import { PAGES } from "@dune/types";
import { PaginatedDataTable, useSidebar } from "@dune/ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useReceiptsQuery } from "../../../../../api/queries/receipt.queries";
import { receiptColumns } from "../../../../receipts/data-table/receipt-columns";
import { usePagination } from "../../../../../hooks/usePagination";
import type { ReceiptExtendedInfo } from "@dune/types";

type BrokerReceiptsTabProps = {
	brokerSocietyId: number;
};

const BrokerReceiptsTab: React.FC<BrokerReceiptsTabProps> = ({
	brokerSocietyId,
}) => {
	const navigate = useNavigate();
	const { state } = useSidebar();
	const isCollapsed = state === "collapsed";
	const { page, limit, handlePageChange, handleLimitChange } = usePagination();

	const {
		data: receiptsResponse,
		isLoading,
		error,
	} = useReceiptsQuery({
		brokerSocietyId,
		page,
		limit,
	});

	const receipts = receiptsResponse?.data ?? [];
	const paginationMeta = receiptsResponse?.meta ?? {
		page: 1,
		limit: 10,
		total: 0,
		totalPages: 0,
		hasNextPage: false,
		hasPreviousPage: false,
	};

	const handleRowClick = (receipt: ReceiptExtendedInfo) => {
		navigate(PAGES.RECEIPTS.show.withParams(receipt.id.toString()));
	};

	if (error) {
		return (
			<div className="flex flex-col items-center justify-center py-12 text-red-600">
				Erreur lors du chargement des quittances.
			</div>
		);
	}

	return (
		<div className="flex-1 min-h-0 w-full overflow-auto">
			<div className={isCollapsed ? "max-w-[92vw]" : "max-w-[80vw]"}>
				<PaginatedDataTable
					data={receipts}
					columns={receiptColumns}
					meta={paginationMeta}
					onPageChange={handlePageChange}
					onLimitChange={handleLimitChange}
					isLoading={isLoading}
					onRowClick={handleRowClick}
					noResultsText="Aucune quittance trouvée"
				/>
			</div>
		</div>
	);
};

export default BrokerReceiptsTab;
